// extracted by mini-css-extract-plugin
export default {"box":"Item_box__dkGTR","line":"Item_line__c6v88","progress":"Item_progress__V4D2x","counter":"Item_counter__INsgH","balance":"Item_balance__Z4VCD"};